//people reducer types
export const LOADING_PROFILE = "LOADING_PROFILE";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_REQUEST_SUCCESS = "FETCH_PROFILE_REQUEST_SUCCESS";
export const PROFILE_SAVE_REQUEST = "PROFILE_SAVE_REQUEST";
export const PROFILE_SAVE_SUCCESS = "PROFILE_SAVE_SUCCESS";
